import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { Job, JobsResponse } from "@/types";

/**
 * This hook is used to update a job for a job query without refetching the entire query.
 * Writes to both the individual job cache and the jobs list cache.
 */
export const useSetJob = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ job }: { job: Job }) => {
    // Update individual job cache (for useGetJob consumers)
    queryClient.setQueryData(["job", currentCompanyId, job.id], job);

    // Update jobs list cache (for useCurrentJobResponse / JobPage)
    queryClient.setQueryData(
      ["jobs", currentCompanyId],
      (cachedData: JobsResponse[] | undefined) => {
        if (!cachedData) return cachedData;
        return cachedData.map((jr) =>
          jr.job.id === job.id ? { ...jr, job } : jr,
        );
      },
    );
  };
};
